export const TYPES = {
  TOGGLE_CROSSOUT: 'toggleCrossOut',
  ENABLE_CROSSOUT: 'enableCrossOut',
  SET_INIT: 'setInit',
  TOGGLE_CROSSOUT_COUNT: 'toggleCrossOutCount',
  SET_CROSSEDOUT_BY_REFERENCE: 'setCrossedOutByReference',
  RESET_CROSSEDOUT_BY_REFERENCE: 'resetCrossedOutByReference',
};

export const defaultValues = {
  init: false,
  isEnabled: false,
  toggleCount: 0,
  crossedOutByReferenceCount: {},
};
export const reducer = (state, action) => {
  switch (action.type) {
    case TYPES.TOGGLE_CROSSOUT_COUNT: {
      return {
        ...state,
        toggleCount: action.payload.toggleCount,
      };
    }
    case TYPES.SET_INIT: {
      return {
        ...state,
        init: true,
      };
    }
    case TYPES.TOGGLE_CROSSOUT: {
      return {
        ...state,
        isEnabled: !state.isEnabled,
      };
    }
    case TYPES.ENABLE_CROSSOUT: {
      return {
        ...state,
        isEnabled: true,
      };
    }
    case TYPES.SET_CROSSEDOUT_BY_REFERENCE: {
      const currentCount =
        state.crossedOutByReferenceCount[action.payload.reference] || 0;
      const count =
        action.payload.type === 'add' ? currentCount + 1 : currentCount - 1;
      return {
        ...state,
        crossedOutByReferenceCount: {
          ...state.crossedOutByReferenceCount,
          [action.payload.reference]: count > 0 ? count : 0,
        },
      };
    }
    case TYPES.RESET_CROSSEDOUT_BY_REFERENCE: {
      return {
        ...state,
        crossedOutByReferenceCount: {
          ...state.crossedOutByReferenceCount,
          [action.payload.reference]: 0,
        },
      };
    }
  }
  throw Error(`Unknown action: ${action.type}`);
};
